import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
  Send, ArrowLeft, CheckCircle2, Shield, Eye, Lock, Users,
} from 'lucide-react';

export const StepFreigabe = ({ ansicht, freitext, zielgruppe, onZurueck, onFreigeben, onRegister, t }) => {
  const erkannt = ansicht?.erkannt;
  const empfehlung = ansicht?.empfehlung;

  return (
    <div className="space-y-6" data-testid="step-freigabe">
      <Card className="border-primary/20 bg-primary/[0.03]">
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
              <Send className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h2 className="font-serif text-xl font-bold text-gray-900 mb-2">
                {t('schnellcheck.step5Title') !== 'schnellcheck.step5Title' ? t('schnellcheck.step5Title') : 'Freigabe für Angebote'}
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                {t('schnellcheck.step5Desc') !== 'schnellcheck.step5Desc'
                  ? t('schnellcheck.step5Desc')
                  : 'Geben Sie Ihren geprüften Fall als Projekt frei. Qualifizierte Dienstleister können darauf Angebote abgeben. Sie behalten jederzeit die volle Kontrolle.'}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Summary */}
      <Card data-testid="freigabe-zusammenfassung">
        <CardContent className="p-6">
          <h3 className="text-sm font-semibold text-gray-900 mb-4">Ihr Fall im Überblick</h3>

          {erkannt?.zusammenfassung_text && (
            <p className="text-sm text-gray-600 mb-4 leading-relaxed">{erkannt.zusammenfassung_text}</p>
          )}

          {erkannt?.erkannte_merkmale?.length > 0 && (
            <div className="flex flex-wrap gap-2 mb-4">
              {erkannt.erkannte_merkmale.map((m, i) => (
                <Badge key={i} variant="secondary" className="bg-primary/8 text-primary text-xs">
                  {m.label}: {m.wert}
                </Badge>
              ))}
            </div>
          )}

          {empfehlung?.empfohlener_weg && (
            <div className="p-3 rounded-lg bg-emerald-50 border border-emerald-200 mt-3">
              <p className="text-xs font-medium text-emerald-700 mb-1">Empfohlener Weg:</p>
              <p className="text-sm text-emerald-800">{empfehlung.empfohlener_weg}</p>
            </div>
          )}
        </CardContent>
      </Card>

      {/* What happens */}
      <Card data-testid="freigabe-info">
        <CardContent className="p-6 space-y-4">
          <h3 className="text-sm font-semibold text-gray-900">Was bei der Freigabe passiert</h3>
          <div className="space-y-3">
            {[
              { icon: Eye, text: 'Ihr Projekt wird für passende Dienstleister sichtbar (anonymisiert)' },
              { icon: Users, text: 'Qualifizierte Anbieter können Ihnen Angebote unterbreiten' },
              { icon: Lock, text: 'Ihre persönlichen Daten bleiben geschützt' },
              { icon: Shield, text: 'Sie können das Projekt jederzeit ändern oder zurückziehen' },
            ].map(({ icon: Icon, text }, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-primary/8 flex items-center justify-center shrink-0">
                  <Icon className="h-4 w-4 text-primary" />
                </div>
                <p className="text-sm text-gray-600 pt-1.5">{text}</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Actions */}
      <div className="space-y-3">
        <Button
          onClick={onFreigeben}
          className="w-full h-12 text-base"
          data-testid="freigabe-absenden-btn"
        >
          <Send className="h-4 w-4 mr-2" />
          Projekt freigeben & speichern
        </Button>
        <div className="flex gap-3">
          <Button variant="outline" onClick={onZurueck} className="flex-1" data-testid="freigabe-zurueck-btn">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Zurück
          </Button>
          <Button variant="ghost" onClick={onRegister} className="flex-1 text-gray-500" data-testid="freigabe-spaeter-btn">
            Später freigeben
          </Button>
        </div>
      </div>
    </div>
  );
};
